"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var Observable_1 = require("rxjs/Observable");
var authorization_service_1 = require("../api/authorization.service");
var access_1 = require("../model/enum/access");
var PermissionGuard = /** @class */ (function () {
    function PermissionGuard(authorizationService, authenticationService, router) {
        this.authorizationService = authorizationService;
        this.authenticationService = authenticationService;
        this.router = router;
    }
    PermissionGuard.prototype.canActivate = function (childRoute, state) {
        var _this = this;
        var permissionKeys = childRoute.data['permissionKey'];
        return this.authenticationService.getUserData().flatMap(function (userData) {
            var accessList = permissionKeys.map(function (permissionKey) { return _this.authorizationService.getPermissionAccessValue(userData.userId, permissionKey)
                .map(function (perm) { return perm.access == access_1.Access.FULL; }); });
            if (accessList.length == 0) {
                return Observable_1.Observable.of(true);
            }
            return Observable_1.Observable.combineLatest(accessList)
                .map(function (accessList) {
                var hasAccess = accessList.some(function (value) { return value === true; });
                if (!hasAccess) {
                    _this.router.navigate(['/login']);
                }
                return hasAccess;
            });
        });
    };
    PermissionGuard = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [authorization_service_1.AuthorizationService,
            idm_authentication_client_js_1.AuthenticationService,
            router_1.Router])
    ], PermissionGuard);
    return PermissionGuard;
}());
exports.PermissionGuard = PermissionGuard;
//# sourceMappingURL=permission.guard.js.map